import { useDispatch } from "react-redux"
import { message } from "state_management"
import { FaCloudArrowUp } from "react-icons/fa6"
import useFileAttachments from "components/FileAttachment/useFileAttachments"
import useT from "utils/hooks/useT"
import MessageList from "./MessageList"
import Sender from "./Sender"

export default function Conversation({
  title,
  subtitle,
  messages,
  loaderVisible,
  inputDisabled,
  handleNewUserMessage,
  toolbarSlot,
  children,
}) {
  const dispatch = useDispatch()
  const { t } = useT("common")
  const { files, addFiles, removeFile, clearFiles, isDragging, dropZoneRef, handlePaste } =
    useFileAttachments((msg) => dispatch(message.warning(msg)))

  return (
    <div className="chatbot-widget-conversation file-drop-zone" ref={dropZoneRef}>
      <header className="chatbot-widget-header">
        <div className="chatbot-widget-header-text">
          {title && <h4>{title}</h4>}
          {subtitle && <span>{subtitle}</span>}
        </div>
        {toolbarSlot && <div className="chatbot-widget-header-toolbar">{toolbarSlot}</div>}
      </header>
      <MessageList messages={messages} loaderVisible={loaderVisible} />
      <Sender
        inputDisabled={inputDisabled}
        handleNewUserMessage={handleNewUserMessage}
        files={files}
        onAddFiles={addFiles}
        onRemoveFile={removeFile}
        onClearFiles={clearFiles}
        onPaste={handlePaste}
      >
        {children}
      </Sender>
      {isDragging && (
        <div className="file-drop-overlay">
          <FaCloudArrowUp className="file-drop-icon" />
          <span className="file-drop-text">{t("dropFilesHere")}</span>
          <span className="file-drop-hint">PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP</span>
        </div>
      )}
    </div>
  )
}
